/**
 * Sticky reveal.
 *
 * Tiene ferma una sezione contrassegnata da [data-sticky-reveal] quando il suo
 * bordo inferiore raggiunge quello del viewport, così che le sezioni successive
 * le scorrano sopra.
 *
 * Il CSS vive nella sezione che usa l'effetto; qui si calcola soltanto il valore
 * di `top`, che non è esprimibile in CSS perché dipende dall'altezza resa della
 * sezione (variabile con formato, larghezza e contenuto del titolo).
 */

const SELECTOR = '[data-sticky-reveal]';
const BOUND = 'stickyRevealBound';

/** @param {HTMLElement} wrapper */
function update(wrapper) {
  const offset = Math.min(0, window.innerHeight - wrapper.getBoundingClientRect().height);
  wrapper.style.setProperty('--sticky-reveal-top', `${Math.round(offset)}px`);
}

const resizeObserver = new ResizeObserver((entries) => {
  for (const entry of entries) update(/** @type {HTMLElement} */ (entry.target));
});

/** @returns {HTMLElement[]} i wrapper di sezione che ospitano l'effetto */
function wrappers() {
  return [...document.querySelectorAll(SELECTOR)]
    .map((section) => section.closest('[id^="shopify-section-"]'))
    .filter((wrapper) => wrapper instanceof HTMLElement);
}

function init() {
  for (const wrapper of wrappers()) {
    update(wrapper);
    if (wrapper.dataset[BOUND] === 'true') continue;
    wrapper.dataset[BOUND] = 'true';
    resizeObserver.observe(wrapper);
  }
}

init();

// Un resize della sola finestra non fa scattare il ResizeObserver: l'altezza
// del wrapper resta invariata mentre quella del viewport cambia.
window.addEventListener('resize', init, { passive: true });

// Nel theme editor la sezione viene rimontata a ogni modifica.
document.addEventListener('shopify:section:load', init);
